import { j as json } from "../../../../../../chunks/index2.js";
import { h as handleRequest } from "../../../../../../chunks/utils.js";
import admin from "firebase-admin";
const ensureUserId = async (userDoc) => {
  const user = userDoc.data();
  if (userDoc.id.includes("@glimmr.com")) {
    const userCollection = admin.firestore().collection("users");
    await userDoc.ref.delete();
    await userCollection.doc(user.id).set(user);
  }
};
const GET = handleRequest(async () => {
  const userCollection = admin.firestore().collection("users");
  const users = await userCollection.get();
  const promises = users.docs.map(ensureUserId);
  await Promise.all(promises);
  return json({
    success: true
  });
});
export {
  GET
};
